import { CancelToken } from 'axios';
import { api } from 'services/axios';
import { People, PeopleAPIModel } from 'types/models';
import mapPeopleFromAPI from 'utils/mapFunctions/mapPeople';


export const fetchManyUsers = (
    tokenSource: CancelToken,
    options?: ServiceOptions.FindManyOptions,
): Promise<{ users: People[]; totalCount: number }> => {
    return new Promise((resolve, reject) => {
        const params: ServiceOptions.FindManyOptions = {
            page: options?.page,
            limit: options?.limit,
        };

        api.get<PeopleAPIModel[]>('/user', {
            cancelToken: tokenSource,
            params,
        })
            .then((response) => {
                if (response) {
                    const data = response.data;
                    const totalCount = response.headers['x-total-count'];
                    const users = data.map((eventFromApi) =>
                        mapPeopleFromAPI(eventFromApi)
                    );
                    resolve({
                        users,
                        totalCount,
                    });
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};


export const fetchOneUser = (
    tokenSource: CancelToken,
    id: number
): Promise<People> => {
    return new Promise((resolve, reject) => {
        api.get<PeopleAPIModel>(`/user/${id}`, {
            cancelToken: tokenSource,
        })
            .then((response) => {
                
                const data = response.data;
                const user = mapPeopleFromAPI(data);

                resolve(user);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export interface FetchManyUsersFromEventOptions extends ServiceOptions.FindManyOptions {
    search?: string;
    minWorkload?: number;
}

export const fetchManyUsersFromEvent = (
    eventId : number,
    tokenSource: CancelToken,
    options?: FetchManyUsersFromEventOptions,
): Promise<{ users: People[]; totalCount: number }> => {
    return new Promise((resolve, reject) => {
        const params = {
            page: options?.page,
            limit: options?.limit,
            search: options?.search,
            minWorkload: options?.minWorkload,
        };

        api.get<PeopleAPIModel[]>(`/user/event/${eventId}`, {
            cancelToken: tokenSource,
            params,
        })
            .then((response) => {
                if (response) {
                    const data = response.data;
                    const users = data.map((eventFromApi) =>
                        mapPeopleFromAPI(eventFromApi)
                    );
                    const totalCount = parseInt(response.headers['x-total-count'] || '0', 10);
                    resolve({ users, totalCount });
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};
